module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-400-regular-4d36f25f3d4f0c081914031011a6a2a0.woff";